import { images } from '../constants';

const blogs = [
  {
    id: 1,
    image: images.blog1,
    category: "Interior Design",
    date: "12 June, 2025",
    admin: "Admin",
    heading: "Designing Modern Living Spaces",
    important: {
      content: "A well-designed living space is both functional and expressive. By blending style with practicality, you can create interiors that feel modern, inviting, and uniquely yours.",
      intro: "Design Specialist"
    },
    paragraph: {
      para1: "Redefine your home with fresh ideas for modern living spaces. Discover how layout, furniture, and subtle design choices can dramatically impact the comfort and flow of your home.",
      para2: "Whether you're working with open-concept layouts or compact apartments, modern design favors clean lines, minimalist decor, and intentional use of light and space. Explore how small adjustments can make big impressions.",
      para3: "Learn how to mix materials like wood, glass, and metal for an updated yet timeless look. Incorporate statement furniture, neutral palettes, and texture-rich elements to bring warmth and character to any room.",
      para4: "Get inspired with real-life examples of transformed living rooms, cozy reading nooks, and multifunctional spaces. Let these designs spark your creativity as you build a home that reflects your lifestyle and taste."
    },
    gallery: [
      images.blog1Gallery1,
      images.blog1Gallery2
    ],
    tags: ["design", "modern", "spaces"],
    comments: [
      {
        id: 1,
        image: images.blog1Comment1,
        name: "Emily Carter",
        date: "13 June, 2025",
        content: "Loved the mix of simplicity and elegance in these ideas! Definitely trying some of these concepts in my living room.",
        replies: [
          {
            id: 1,
            image: images.blog1Comment2,
            name: "Noah Bennett",
            date: "13 June, 2025",
            content: "Same here! The layout suggestions are exactly what I needed."
          }
        ]
      },
      {
        id: 2,
        image: images.blog1Comment3,
        name: "Olivia Harris",
        date: "13 June, 2025",
        content: "Great insights. Can you also share ideas for smaller studio spaces?"
      }
    ]
  },
  {
    id: 2,
    image: images.blog2,
    category: "Architecture",
    date: "13 June, 2025",
    admin: "Admin",
    heading: "Innovative Architectural Trends",
    important: {
      content: "From sustainable materials to smart buildings, today’s architecture is transforming the way we live and interact with our spaces. Explore cutting-edge trends that are reshaping modern design.",
      intro: "Architecture Expert"
    },
    paragraph: {
      para1: "Architecture is evolving rapidly with a focus on sustainability, technology integration, and human-centric design. Discover how modern architects are reimagining structures for the future.",
      para2: "Trends like green rooftops, 3D-printed homes, modular construction, and passive energy design are leading the way. These innovations not only reduce environmental impact but also improve quality of life.",
      para3: "Explore how smart homes, adaptable floor plans, and biophilic design are becoming staples in residential and commercial projects. Architects are blending nature, technology, and functionality like never before.",
      para4: "These trends offer a glimpse into the future of living and working spaces. Whether you're building new or renovating, get inspired by these architectural breakthroughs that prioritize sustainability and style."
    },
    gallery: [
      images.blog2Gallery1,
      images.blog2Gallery2
    ],
    tags: ["architecture", "trends", "design"],
    comments: [
      {
        id: 1,
        image: images.blog2Comment1,
        name: "Liam Roberts",
        date: "13 June, 2025",
        content: "Fascinating read! The use of smart technology in buildings is something I’m deeply interested in.",
        replies: [
          {
            id: 1,
            image: images.blog2Comment2,
            name: "Sophie Turner",
            date: "13 June, 2025",
            content: "Absolutely! Smart homes are the future. Would love to see a blog focused solely on that."
          }
        ]
      },
      {
        id: 2,
        image: images.blog2Comment3,
        name: "Ethan Green",
        date: "13 June, 2025",
        content: "Great overview of trends. I’m currently exploring modular construction for a personal project—this was helpful!"
      }
    ]
  },
  {
    id: 3,
    image: images.blog3,
    category: "Interior Design",
    date: "13 June, 2025",
    admin: "Admin",
    heading: "Interior Design Tips for Small Spaces",
    important: {
      content: "Designing small spaces requires creativity and smart planning. With the right strategies, even the most compact areas can feel open, functional, and stylish.",
      intro: "Space Optimization Specialist"
    },
    paragraph: {
      para1: "Maximize your home’s potential by mastering the art of small space design. Discover layout ideas, multifunctional furniture solutions, and visual tricks that create the illusion of space.",
      para2: "Use light colors, vertical storage, and open shelving to avoid clutter and open up the room. Mirrors, lighting, and minimalism play a huge role in making compact spaces feel larger and brighter.",
      para3: "Every inch counts in small interiors. Learn how to choose the right furniture, scale décor, and incorporate smart storage options that blend beauty with practicality.",
      para4: "Whether you're in a studio apartment or just want to make the most of a tight room, these design tips will help you create a cozy, modern, and well-organized space that reflects your style."
    },
    gallery: [
      images.blog3Gallery1,
      images.blog3Gallery2
    ],
    tags: ["interior", "design", "spaces"],
    comments: [
      {
        id: 1,
        image: images.blog3Comment1,
        name: "Charlotte Miller",
        date: "13 June, 2025",
        content: "This is exactly what I needed for my apartment! Love the storage tips.",
        replies: [
          {
            id: 1,
            image: images.blog3Comment2,
            name: "Grace Parker",
            date: "13 June, 2025",
            content: "Same here! The mirror trick really works wonders in tight hallways."
          }
        ]
      },
      {
        id: 2,
        image: images.blog3Comment3,
        name: "Daniel Wright",
        date: "13 June, 2025",
        content: "Would love a follow-up on multifunctional furniture recommendations!"
      }
    ]
  },
  {
    id: 4,
    image: images.blog4,
    category: "Architecture",
    date: "13 June, 2025",
    admin: "Admin",
    heading: "Architectural Marvels Around the World",
    important: {
      content: "Explore some of the most breathtaking architectural landmarks across the globe. From ancient wonders to modern masterpieces, these structures showcase human creativity and engineering brilliance.",
      intro: "Global Architecture Enthusiast"
    },
    paragraph: {
      para1: "Architecture tells a story—of culture, ambition, and innovation. Take a virtual journey to iconic sites that define the skylines of cities and inspire generations of architects.",
      para2: "From the timeless beauty of the Taj Mahal to the futuristic curves of the Sydney Opera House, these marvels span continents and centuries, each with a unique design philosophy and historical significance.",
      para3: "Discover lesser-known gems like the Lotus Temple in Delhi, the Dancing House in Prague, or the Bosco Verticale in Milan. These structures blend form and function in visually stunning ways.",
      para4: "Whether you're a design lover, traveler, or architecture student, this roundup offers visual and cultural inspiration from around the world. Let these architectural feats spark your curiosity and creativity."
    },
    gallery: [
      images.blog4Gallery1,
      images.blog4Gallery2
    ],
    tags: ["architecture", "modern", "design"],
    comments: [
      {
        id: 1,
        image: images.blog4Comment1,
        name: "Ava Thompson",
        date: "13 June, 2025",
        content: "What a beautiful curation of global architecture! Would love to see a follow-up with hidden gems.",
        replies: [
          {
            id: 1,
            image: images.blog4Comment2,
            name: "Lucas Bennett",
            date: "13 June, 2025",
            content: "Agreed! This was a joy to scroll through—so inspiring."
          }
        ]
      },
      {
        id: 2,
        image: images.blog4Comment3,
        name: "Mia Wilson",
        date: "13 June, 2025",
        content: "Can you do a series focused on sustainable architectural marvels next?"
      }
    ]
  },
  {
    id: 5,
    image: images.blog5,
    category: "Interior Design",
    date: "13 June, 2025",
    admin: "Admin",
    heading: "Choosing Interior Colors for Your Home",
    important: {
      content: "Color has the power to completely transform a space. Choosing the right palette can set the mood, enhance natural light, and reflect your personal style throughout your home.",
      intro: "Color Consultant"
    },
    paragraph: {
      para1: "Selecting interior colors is more than just picking your favorite shade—it's about creating harmony, contrast, and visual flow. Learn how color theory and psychology can help guide your decisions.",
      para2: "From soft neutrals that calm to bold tones that energize, the right colors can make small rooms feel larger and open spaces feel cozy. Understand how lighting, room size, and function influence your palette.",
      para3: "Explore timeless combinations like gray and white, earth tones with greenery, or trending colors like sage green, deep navy, and terracotta. Find inspiration in nature, textiles, and even your artwork.",
      para4: "Whether you're painting a whole room or adding pops of color through decor, these tips will help you choose a scheme that enhances your home's personality and atmosphere."
    },
    gallery: [
      images.blog5Gallery1,
      images.blog5Gallery2
    ],
    tags: ["interior", "color", "design"],
    comments: [
      {
        id: 1,
        image: images.blog5Comment1,
        name: "Ella Morgan",
        date: "13 June, 2025",
        content: "This helped me finally decide on a color for my bedroom—thank you!",
        replies: [
          {
            id: 1,
            image: images.blog5Comment2,
            name: "Lily Scott",
            date: "13 June, 2025",
            content: "Same here! I love the earthy tones idea, it feels so calming."
          }
        ]
      },
      {
        id: 2,
        image: images.blog5Comment3,
        name: "Henry Adams",
        date: "13 June, 2025",
        content: "Would love more info on coordinating colors between open spaces!"
      }
    ]
  },
  {
    id: 6,
    image: images.blog6,
    category: "Architecture",
    date: "13 June, 2025",
    admin: "Admin",
    heading: "Incorporating Nature in Architectural Design",
    important: {
      content: "Biophilic architecture is more than a trend—it’s a movement that reconnects buildings with the natural world. Integrating nature into design creates healthier, more inspiring spaces.",
      intro: "Eco-Design Architect"
    },
    paragraph: {
      para1: "Incorporating nature into architectural design promotes wellbeing, sustainability, and a deep connection to the environment. Discover how designers are blending built spaces with the natural world.",
      para2: "Features like green walls, indoor gardens, large windows, and natural materials bring organic elements indoors. These choices enhance air quality, reduce stress, and improve the user experience.",
      para3: "Architects are increasingly designing with natural light, ventilation, and views in mind. Rooftop gardens, water features, and landscape integration make spaces feel alive and restorative.",
      para4: "Whether you're renovating or building new, this nature-forward approach can transform how people feel and function within a space. Learn practical ideas and inspiring examples to bring nature home."
    },
    gallery: [
      images.blog6Gallery1,
      images.blog6Gallery2
    ],
    tags: ["nature", "architecture", "design"],
    comments: [
      {
        id: 1,
        image: images.blog6Comment1,
        name: "Noah Carter",
        date: "13 June, 2025",
        content: "Biophilic design has completely changed my perspective—amazing article!",
        replies: [
          {
            id: 1,
            image: images.blog6Comment2,
            name: "Chloe Rivera",
            date: "13 June, 2025",
            content: "It’s such a calming approach. I'd love tips for apartment dwellers!"
          }
        ]
      },
      {
        id: 2,
        image: images.blog6Comment3,
        name: "James Lee",
        date: "13 June, 2025",
        content: "Hope you cover more nature-driven urban designs in future posts."
      }
    ]
  },
  {
    id: 7,
    image: images.blog7,
    category: "Home Styling",
    date: "13 June, 2025",
    admin: "Admin",
    heading: "Creating Stylish Contemporary Homes",
    important: {
      content: "Contemporary homes blend comfort, clean lines, and bold aesthetics. By combining function with beauty, you can craft spaces that feel both timeless and modern.",
      intro: "Modern Home Consultant"
    },
    paragraph: {
      para1: "Contemporary design emphasizes simplicity, subtle sophistication, and purposeful use of space. Learn how to create interiors that are sleek, stylish, and livable.",
      para2: "Neutral color palettes, open floor plans, and statement pieces are essential elements of contemporary homes. Think large windows, minimalist furniture, and layered lighting.",
      para3: "Balance is key—blend textures like concrete, glass, and wood for visual interest. Use accent walls, sculptural decor, and curated art to express personality without clutter.",
      para4: "Whether renovating or decorating from scratch, these tips will help you build a refined space that reflects modern living while remaining warm and inviting."
    },
    gallery: [
      images.blog7Gallery1,
      images.blog7Gallery2
    ],
    tags: ["modern", "interior", "spaces"],
    comments: [
      {
        id: 1,
        image: images.blog7Comment1,
        name: "Sophia Hughes",
        date: "13 June, 2025",
        content: "Love the mix of simplicity and elegance—definitely using these ideas in my remodel!",
        replies: [
          {
            id: 1,
            image: images.blog7Comment2,
            name: "Mason Gray",
            date: "13 June, 2025",
            content: "Same here—more tips on combining materials would be great!"
          }
        ]
      },
      {
        id: 2,
        image: images.blog7Comment3,
        name: "Avery Brooks",
        date: "13 June, 2025",
        content: "This style really speaks to me. Clean but cozy. Thanks for the inspiration!"
      }
    ]
  },
  {
    id: 8,
    image: images.blog8,
    category: "Architecture",
    date: "13 June, 2025",
    admin: "Admin",
    heading: "Emerging Trends in Architecture",
    important: {
      content: "As technology evolves and sustainability becomes essential, architecture continues to push boundaries. Discover the latest trends shaping the future of buildings and urban spaces.",
      intro: "Futurist Architect"
    },
    paragraph: {
      para1: "Architecture is entering a new era—where innovation, sustainability, and human-centered design lead the way. Explore the emerging trends redefining how we live and interact with our environments.",
      para2: "Modular construction, adaptive reuse, and green infrastructure are reshaping both residential and commercial spaces. These approaches offer flexibility, efficiency, and environmental responsibility.",
      para3: "Technology is playing a bigger role with smart buildings, parametric design, and AI-driven planning. Meanwhile, materials like cross-laminated timber and translucent concrete are expanding design possibilities.",
      para4: "Stay ahead of the curve with these architectural trends that prioritize sustainability, well-being, and connectivity. Whether you're an architect or enthusiast, these ideas offer a glimpse into architecture’s bold future."
    },
    gallery: [
      images.blog8Gallery1,
      images.blog8Gallery2
    ],
    tags: ["trends", "architecture", "modern"],
    comments: [
      {
        id: 1,
        image: images.blog8Comment1,
        name: "Liam Parker",
        date: "13 June, 2025",
        content: "Loved the insights on smart buildings and adaptive reuse—really exciting direction!",
        replies: [
          {
            id: 1,
            image: images.blog8Comment2,
            name: "Zoe Ramirez",
            date: "13 June, 2025",
            content: "Totally agree! These innovations are changing the game."
          }
        ]
      },
      {
        id: 2,
        image: images.blog8Comment3,
        name: "Ethan Walker",
        date: "13 June, 2025",
        content: "Would enjoy a deep dive on sustainable materials in one of your next posts."
      }
    ]
  },
  {
    id: 9,
    image: images.blog9,
    category: "Small Space Design",
    date: "13 June, 2025",
    admin: "Admin",
    heading: "Smart Interior Ideas for Compact Areas",
    important: {
      content: "Designing small spaces doesn’t mean compromising on style or functionality. With the right approach, compact areas can feel spacious, efficient, and beautifully organized.",
      intro: "Space Optimization Expert"
    },
    paragraph: {
      para1: "Maximizing a small space begins with smart planning and clever design solutions. Learn how to make every square foot count without overcrowding your home.",
      para2: "Opt for multi-functional furniture, wall-mounted storage, and mirrors to create the illusion of depth. Light color palettes and open shelving also help open up tight areas.",
      para3: "Sliding doors, fold-away desks, and vertical storage can dramatically boost efficiency in compact rooms. Design with intent and eliminate unnecessary clutter for a clean, airy vibe.",
      para4: "Whether it’s a studio apartment, a guest room, or a small home office, these practical tips will help you create a stylish and functional space that doesn’t feel cramped."
    },
    gallery: [
      images.blog9Gallery1,
      images.blog9Gallery2
    ],
    tags: ["interior", "spaces", "design"],
    comments: [
      {
        id: 1,
        image: images.blog9Comment1,
        name: "Olivia Bennett",
        date: "13 June, 2025",
        content: "These ideas are exactly what I needed for my tiny city apartment—thank you!",
        replies: [
          {
            id: 1,
            image: images.blog9Comment2,
            name: "Jackson Reid",
            date: "13 June, 2025",
            content: "Love the use of fold-away furniture—such a space saver!"
          }
        ]
      },
      {
        id: 2,
        image: images.blog9Comment3,
        name: "Harper Collins",
        date: "13 June, 2025",
        content: "Would love to see a visual guide for small kitchen layouts next!"
      }
    ]
  },
  {
    id: 10,
    image: images.blog10,
    category: "Architecture",
    date: "13 June, 2025",
    admin: "Admin",
    heading: "Global Wonders of Architecture",
    important: {
      content: "From ancient marvels to modern masterpieces, the world is filled with awe-inspiring architectural wonders that tell stories of culture, innovation, and vision.",
      intro: "Cultural Architecture Curator"
    },
    paragraph: {
      para1: "Architecture transcends function—it becomes art, history, and identity. This post celebrates some of the most iconic structures around the globe, spanning eras and continents.",
      para2: "Explore the enduring majesty of the Taj Mahal, the towering ambition of Burj Khalifa, and the organic brilliance of Gaudí’s Sagrada Família. Each structure reflects a unique cultural and architectural philosophy.",
      para3: "Architectural wonders also include sustainable innovations like Singapore’s Gardens by the Bay and Beijing’s Bird’s Nest Stadium, blending modern technology with deep respect for environment and form.",
      para4: "Let this global tour inspire your own design ideas and appreciation for the powerful role architecture plays in shaping our world and experiences across generations."
    },
    gallery: [
      images.blog10Gallery1,
      images.blog10Gallery2
    ],
    tags: ["architecture", "modern", "trends"],
    comments: [
      {
        id: 1,
        image: images.blog10Comment1,
        name: "Isabelle Thompson",
        date: "13 June, 2025",
        content: "Incredible lineup! I'd love to visit every place mentioned here someday.",
        replies: [
          {
            id: 1,
            image: images.blog10Comment2,
            name: "Elias Murphy",
            date: "13 June, 2025",
            content: "Same here—Gaudí’s work in Barcelona is top of my list!"
          }
        ]
      },
      {
        id: 2,
        image: images.blog10Comment3,
        name: "Victoria Zhang",
        date: "13 June, 2025",
        content: "A stunning celebration of architecture as a global language—thank you for this!"
      }
    ]
  },
  {
    id: 11,
    image: images.blog11,
    category: "Interior Design",
    date: "13 June, 2025",
    admin: "Admin",
    heading: "How to Pick the Right Colors for Your Interiors",
    important: {
      content: "Choosing the right color palette is crucial for setting the mood and style of your interior. The perfect colors can transform any space into a warm, inviting, and cohesive environment.",
      intro: "Color Psychology Expert"
    },
    paragraph: {
      para1: "Color influences how we feel and interact with a space. From calming neutrals to bold accent tones, your choices shape both function and emotion in your home.",
      para2: "Start with the purpose of each room—cool blues and greens work well in bedrooms for relaxation, while warmer tones like terracotta or mustard can energize a living area or kitchen.",
      para3: "Don’t underestimate the impact of lighting. Natural light brings out truer tones, while artificial lighting can shift how colors appear. Always test swatches before committing.",
      para4: "Balance is key. Mix neutral bases with colorful accents for depth and flexibility. Whether you're going for a timeless aesthetic or something trend-driven, the right palette makes all the difference."
    },
    gallery: [
      images.blog11Gallery1,
      images.blog11Gallery2
    ],
    tags: ["color", "interior", "design"],
    comments: [
      {
        id: 1,
        image: images.blog11Comment1,
        name: "Grace Delaney",
        date: "13 June, 2025",
        content: "This helped me finally commit to a color scheme for my living room—thank you!",
        replies: [
          {
            id: 1,
            image: images.blog11Comment2,
            name: "Nathan Cole",
            date: "13 June, 2025",
            content: "Totally agree! Lighting tips were especially helpful."
          }
        ]
      },
      {
        id: 2,
        image: images.blog11Comment3,
        name: "Elena Foster",
        date: "13 June, 2025",
        content: "More posts like this, please! Maybe a deep dive on paint finishes?"
      }
    ]
  },
  {
    id: 12,
    image: images.blog12,
    category: "Sustainable Design",
    date: "13 June, 2025",
    admin: "Admin",
    heading: "Blending Nature with Architectural Concepts",
    important: {
      content: "Nature-inspired architecture isn't just beautiful—it's essential for sustainable living. Discover how integrating natural elements enhances both environmental impact and human well-being.",
      intro: "Sustainable Design Strategist"
    },
    paragraph: {
      para1: "Architecture that harmonizes with nature is more than a trend—it's a philosophy. It connects people with the environment while promoting energy efficiency, wellness, and visual serenity.",
      para2: "Features like green roofs, indoor gardens, and passive ventilation reduce ecological footprints and bring the outdoors in. Natural materials such as stone, bamboo, and reclaimed wood support both aesthetics and sustainability.",
      para3: "Design strategies like biophilic design and site-sensitive construction ensure buildings coexist with their surroundings. These approaches embrace organic forms, natural light, and landscape integration.",
      para4: "Blending nature with architecture creates timeless spaces that nourish the soul and the environment. Whether in urban or rural settings, it’s a design direction that enriches life on every level."
    },
    gallery: [
      images.blog12Gallery1,
      images.blog12Gallery2
    ],
    tags: ["nature", "architecture", "design"],
    comments: [
      {
        id: 1,
        image: images.blog12Comment1,
        name: "Julian Hart",
        date: "13 June, 2025",
        content: "Absolutely love this approach—nature-connected spaces are so calming!",
        replies: [
          {
            id: 1,
            image: images.blog12Comment2,
            name: "Lara Nguyen",
            date: "13 June, 2025",
            content: "I’ve started adding indoor plants and natural textures—huge difference already."
          }
        ]
      },
      {
        id: 2,
        image: images.blog12Comment3,
        name: "Theo Brooks",
        date: "13 June, 2025",
        content: "Would love to see case studies on homes or offices using this style!"
      }
    ]
  }

];

export default blogs;